import DoceboAPI, {
  DoceboCourseDetail,
  DoceboLearningObjectPlayDetail,
  DoceboLearningObjectTrackDetail,
  DoceboLoTrackResponse,
  DoceboLoTrackType,
} from '@/lib/DoceboAPI';
import Vue from 'vue';
import Vuex, { ActionTree, GetterTree, MutationTree } from 'vuex';

interface LocalState {
  courseDetail: { [courseId: string]: DoceboCourseDetail };
}

Vue.use(Vuex);

const doceboAPI = DoceboAPI.instance;

const namespaced = true;

const localState: LocalState = {
  courseDetail: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getters: GetterTree<LocalState, any> = {};

const mutations: MutationTree<LocalState> = {
  SET_COURSE_DETAIL: (state, courseDetail: DoceboCourseDetail) => {
    Vue.set(state.courseDetail, courseDetail.data.id.toString(), courseDetail);
  },
};

const actions: ActionTree<LocalState, unknown> = {
  GET_COURSE_DETAIL: (context, courseId): Promise<void> =>
    doceboAPI
      .getCourseDetail(courseId)
      .then((courseDetailData: DoceboCourseDetail) => {
        context.commit('SET_COURSE_DETAIL', courseDetailData);
      }),

  GET_COURSE_LEARNING_OBJECT_DETAIL: (
    _context,
    loId: string
  ): Promise<DoceboLearningObjectPlayDetail> =>
    doceboAPI.getLearningObjectPlayDetail(loId),

  GET_COURSE_LEARNING_OBJECT_TRACK_DETAIL: (
    _context,
    loId: string
  ): Promise<DoceboLearningObjectTrackDetail> =>
    doceboAPI.getLearningObjectTrackDetail(loId),

  TRACK_LO: (
    _context,
    payload: {
      loId: string;
      data: DoceboLoTrackType;
    }
  ): Promise<DoceboLoTrackResponse> =>
    doceboAPI.trackLo(payload.loId, payload.data),
};

export { namespaced, localState as state, getters, mutations, actions };
